import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAText, Icon } from '@alucio/lux-ui';
const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        height: '100%',
        alignItems: 'center',
    },
    icon: {
        width: 120,
        height: 120,
        color: 'rgba(255,255,255,0.4)',
    },
    errMessage: {
        color: 'white',
        top: '40%',
        position: 'absolute',
        textAlign: 'center',
        marginHorizontal: 8,
    },
});
var MediaAccessState;
(function (MediaAccessState) {
    MediaAccessState[MediaAccessState["unknown"] = 0] = "unknown";
    MediaAccessState[MediaAccessState["prompted"] = 1] = "prompted";
    MediaAccessState[MediaAccessState["allowed"] = 2] = "allowed";
    MediaAccessState[MediaAccessState["denied"] = 3] = "denied";
    MediaAccessState[MediaAccessState["notAvailable"] = 4] = "notAvailable";
    MediaAccessState[MediaAccessState["notFound"] = 5] = "notFound";
})(MediaAccessState || (MediaAccessState = {}));
export default function ParticipantMeetingPlaceholder(props) {
    const { placeholderIconStyle, customContainerStyle, videoAccessState, showTextErr } = props;
    let message;
    if (showTextErr) {
        if (videoAccessState === MediaAccessState.denied) {
            message = 'You blocked access to your camera';
        }
        else if (videoAccessState === MediaAccessState.notAvailable) {
            message = 'Your camera is being used by another application. ' +
                'Please close all other apps that may be using your camera';
        }
        else if (videoAccessState === MediaAccessState.notFound) {
            message = 'We were unable to detect your camera';
        }
    }
    const placeholderContent = (showTextErr) ? (React.createElement(DNAText, { style: styles.errMessage, adjustsFontSizeToFit: true }, message)) : (React.createElement(Icon, { style: [styles.icon, placeholderIconStyle], name: "account" }));
    return (React.createElement(DNABox, { alignX: "center", alignY: "start", style: [styles.container, customContainerStyle] }, placeholderContent));
}
//# sourceMappingURL=ParticipantMeetingPlaceholder.js.map